import(/* webpackMode: "eager" */ "/app/frontend/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/GeistVF.woff\",\"variable\":\"--font-geist-sans\",\"weight\":\"100 900\"}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/app/frontend/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/GeistMonoVF.woff\",\"variable\":\"--font-geist-mono\",\"weight\":\"100 900\"}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager" */ "/app/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppShell"] */ "/app/frontend/src/components/layout/app-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/frontend/src/components/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["STANDARD_TITEL"] */ "/app/frontend/src/lib/hooks/use-branding.ts");
